import Box from 'components/shared/Box'
import Modal from 'components/shared/Modal'
import SinglePhoto from 'components/shared/Gallery/SinglePhoto'
import { useIntl } from 'react-intl'
import cabanaImage from 'assets/images/cabana/cabana.jpg'
import iconConcierge from 'assets/images/decors/cabana/iconConcierge.svg'
import iconDrink from 'assets/images/decors/cabana/iconDrink.svg'
import iconLandscape from 'assets/images/decors/cabana/iconLandscape.svg'
import iconSunBed from 'assets/images/decors/cabana/iconSunBed.svg'
import IconWithText from 'components/shared/IconWithText'
import Info from 'components/shared/Info'
import { CabanaModalBody } from './styles'
import { UpsellModalProps } from './types'

const CabanaModal = ({ isOpened, closeModal }: UpsellModalProps) => {
    const { formatMessage } = useIntl()
    return (
        <Modal
            isOpened={isOpened}
            maxWidth={670}
            onClose={closeModal}
            isMobileFullscreen={true}
            hasGlobalHeader
            headerMessage="Cabana (16+)"
            testIdPrefix="cabana-box-about"
        >
            <>
                <CabanaModalBody pt={32} pl={[16, 40]} pr={[16, 40]} pb={40}>
                    <Box
                        direction={['column', 'row']}
                        gap={[16, 0]}
                        justify="space-between"
                        wrap="wrap"
                        isFullWidth
                        mb={[24, 40]}
                    >
                        <IconWithText
                            icon={iconSunBed}
                            iconAlt="sunbed icon"
                            textHighlighted={formatMessage({
                                id: 'upsells.cabanas.modal_sunbed_info',
                                defaultMessage: 'Wygodny, dwuosobowy leżak',
                            })}
                        />
                        <IconWithText
                            icon={iconLandscape}
                            iconAlt="sunset landscape icon"
                            textHighlighted={formatMessage({
                                id: 'upsells.cabanas.modal_reservation_info',
                                defaultMessage: 'Całodniowa rezerwacja',
                            })}
                        />
                        <IconWithText
                            icon={iconDrink}
                            iconAlt="exotic drink icon"
                            textHighlighted={formatMessage({
                                id: 'upsells.cabanas.modal_drinks_info',
                                defaultMessage:
                                    'Lampka prosecco lub napój bezalkoholowy na osobę',
                            })}
                        />
                        <IconWithText
                            icon={iconConcierge}
                            iconAlt="concierge icon"
                            textHighlighted={formatMessage({
                                id: 'upsells.cabanas.modal_service_info',
                                defaultMessage: 'Obsługa concierge',
                            })}
                        />
                    </Box>
                    <Box mb={24}>
                        <Info color="info_warning" hasNoBackground hasBorder>
                            {formatMessage({
                                id: 'upsells.cabanas.modal_wheelchair_info',
                                defaultMessage:
                                    'Strefa z cabanami jest nieprzystosowana dla osób poruszających się na wózku inwalidzkim.',
                            })}
                        </Info>
                    </Box>
                    <SinglePhoto photoPath={cabanaImage} alt="Private cabana" />
                </CabanaModalBody>
            </>
        </Modal>
    )
}

export default CabanaModal
